import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router";

import { useTheme, useMediaQuery } from "@mui/material";

import { Box, Grid, IconButton, styled } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import HomeIcon from "@mui/icons-material/Home";

import { baseUrl } from "config";
import {
  setCompanyInfo,
  setPrintrtTyp,
  setIsDrawerAlways,
  setCommonState,
  setDecimalCount,
  setPrimaryCurrency,
  setSubCurrency,
  setQrShowPrint,
  setIsFree,
  setIsRoundOffInv,
} from "commonSlice/commonSlice";
import { redirectUrl } from "config";
import { setTaxPer } from "./salesPos/slice/discAndTaxPosSlice";
import { setTaxPer as setTaxPercB2c } from "./salesPosB2C/slice/discAndTaxPosSliceB2C";
import filterStatusValue from "utils/filterStatusValue";

const CardWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.light,
  color: theme.palette.secondary.dark,
  overflow: "hidden",
  position: "relative",
  "&:before": {
    content: '""',
    zIndex: 0,
    position: "absolute",
    width: 210,
    height: 210,
    background: `linear-gradient(210.04deg, ${theme.palette.secondary.main} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
    borderRadius: "50%",
    top: -30,
    right: -100,
  },
  "&:after": {
    content: '""',
    position: "absolute",
    zIndex: -1,
    width: 210,
    height: 210,
    background: `linear-gradient(140.9deg, ${theme.palette.secondary.main} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
    borderRadius: "50%",
    top: -140,
    right: -60,
  },
}));
function SalesLayOut() {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const companyInfo = useSelector((state) => state.common.companyInfo);
  const moduleName = useSelector((state) => state.common);

  useEffect(() => {
    function getCompany() {
      axios
        .get(baseUrl + "/main/getCompanyDetails", { withCredentials: true })
        .then((res) => {
          dispatch(setCompanyInfo(res.data[0]));
        });
    }
    function getPrinter() {
      axios({
        method: "get",
        url: baseUrl + "/getPrinterNameAndOther",
        withCredentials: true,
      })
        .then((res) => {
          dispatch(setPrintrtTyp(res?.data));

          const drawerStatus = filterStatusValue(
            res?.data?.[1],
            "params",
            "DRAWER",
          );
          dispatch(
            setIsDrawerAlways(
              drawerStatus?.[0]?.VALUE === "YES" ? true : false,
            ),
          );

          // dispatch(setTaxPer(res.data[1][13]?.VALUE));
          const billWiseTax = filterStatusValue(
            res?.data?.[1],
            "params",
            "bill_Wise_Tax%",
          );
          dispatch(setTaxPer(billWiseTax?.[0]?.VALUE));
          // dispatch(setTaxPercB2c(res.data[1][13]?.VALUE));
          const billWiseTaxB2c = filterStatusValue(
            res?.data?.[1],
            "params",
            "bill_Wise_Tax%",
          );
          dispatch(setTaxPercB2c(billWiseTaxB2c?.[0]?.VALUE));
          // dispatch(setTax())

          const addOnStatus = filterStatusValue(
            res?.data?.[1],
            "params",
            "ADD_ON",
          );
          const allKotStatus = filterStatusValue(
            res?.data?.[1],
            "params",
            "ALL_KOT",
          );
          const kotEnabledStatus = filterStatusValue(
            res?.data?.[1],
            "params",
            "KOT_ENABLED",
          );
          const isRestaurantStatus = filterStatusValue(
            res?.data?.[1],
            "params",
            "IS_RESTAURANT",
          );
          const salesBillDecl = filterStatusValue(
            res?.data?.[1],
            "params",
            "SALESBILL_DECLARATION",
          );
          const orderFormDecl = filterStatusValue(
            res?.data?.[1],
            "params",
            "ORDERFORM_DECLARATION",
          );

          dispatch(
            setCommonState({
              isADDon: addOnStatus?.[0]?.VALUE === "YES" ? true : false,
              allKot: allKotStatus?.[0]?.VALUE === "YES" ? true : false,
              taxUtilitiesListData: res.data[2],
              KotEnabled: kotEnabledStatus?.[0]?.VALUE === "YES" ? true : false,
              IsRestaurant:
                isRestaurantStatus?.[0]?.VALUE === "YES" ? true : false,
              salesBillDeclaration: salesBillDecl?.[0]?.VALUE || "",
              orderFormDeclaration: orderFormDecl?.[0]?.VALUE || "",
            }),
          );

          const decimalValue = filterStatusValue(
            res?.data?.[1],
            "params",
            "DECIMAL_VALUE",
          );
          const fetchedDecimal =
            decimalValue?.[0]?.VALUE !== undefined
              ? decimalValue?.[0]?.VALUE
              : decimalValue?.[0]?.value;
          dispatch(
            setDecimalCount(fetchedDecimal !== undefined ? fetchedDecimal : 2),
          );

          const primaryCurrency = filterStatusValue(
            res?.data?.[1],
            "params",
            "PRIMARY_CURRENCY",
          );
          dispatch(setPrimaryCurrency(primaryCurrency?.[0]?.VALUE));

          const subCurrency = filterStatusValue(
            res?.data?.[1],
            "params",
            "SUB_CURRENCY",
          );
          dispatch(setSubCurrency(subCurrency?.[0]?.VALUE));

          const qrShowStatus = filterStatusValue(
            res?.data?.[1],
            "params",
            "VIEW ZATCA QR",
          );
          dispatch(
            setQrShowPrint(qrShowStatus?.[0]?.VALUE === "YES" ? true : false),
          );
          const isFreeCheck = res?.data?.[1]?.find(
            (item) => item.params === "IS_FREE",
          );
          const IS_FREE = isFreeCheck?.VALUE === "YES";
          dispatch(setIsFree(IS_FREE));

          const roundOffInv = filterStatusValue(
            res?.data?.[1],
            "params",
            "ROUND_OFF_INV",
          );
          const fetchedRoundOff =
            roundOffInv?.[0]?.VALUE !== undefined
              ? roundOffInv?.[0]?.VALUE
              : roundOffInv?.[0]?.value;
          dispatch(setIsRoundOffInv(fetchedRoundOff === "YES" ? true : false));
        })
        .catch((err) => {
          console.error("Error fetching printer settings:", err);
          if (err?.response?.status === 403 || err?.response?.status === 401) {
            redirectUrl();
          }
        });
    }

    getPrinter();
    getCompany();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleHomeClick = () => {
    navigate("/");
  };
  const handleFullscreenToggle = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    setIsFullscreen(!isFullscreen);
  };

  return (
    <>
      <Box sx={{ width: "100%", background: "rgb(238, 242, 246)", height: 50 }}>
        <Box
          sx={{
            // padding: "5px 15px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            background: "#fff",
          }}
          display="flex"
          alignItems="center"
          // justifyContent="space-between"
        >
          <Grid container>
            {!isMdDown && (
              <Grid
                item
                xs={4}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"flex-start"}
              >
                {" "}
                {companyInfo ? (
                  <Box sx={{ fontWeight: 600 }}>{companyInfo.Name}</Box>
                ) : (
                  <Box sx={{ fontWeight: 600 }}>Company Name</Box>
                )}
              </Grid>
            )}

            <Grid
              item
              xs={isMdDown ? 6 : 4}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              {" "}
              <Box sx={{ fontWeight: "bold" }}>{moduleName?.moduleHeading}</Box>
            </Grid>
            <Grid item xs={isMdDown ? 6 : 4}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <IconButton
                    sx={{ fontSize: "2rem" }}
                    aria-label="full screen"
                    onClick={handleHomeClick}
                  >
                    <HomeIcon fontSize="2.5rem" />
                  </IconButton>

                  <IconButton
                    sx={{ fontSize: "2rem" }}
                    aria-label="full screen"
                    onClick={handleFullscreenToggle}
                  >
                    {isFullscreen ? (
                      <FullscreenExitIcon fontSize="2.5rem" />
                    ) : (
                      <FullscreenIcon fontSize="2.5rem" />
                    )}
                  </IconButton>
                  {/* <AccountPop /> */}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <CardWrapper>
          <Outlet />
        </CardWrapper>
      </Box>
    </>
  );
}
export default SalesLayOut;
